import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import * as moment from 'moment';
import { MomentConfiguration } from "./config/moment-config";

@Pipe({
  name: "newKcmsDateTwelve",
  pure: true
})

export class newKcmsDateTwelvePipe extends DatePipe implements PipeTransform {
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  transform(value: any, otherDayformat: string = 'D MMM YYYY', todayFormat: string = 'HH:mm'): string | null {
    if (value) {
      if (value != null && value !== '' && value !== 'none' && value !== 'None') {

        this.offsetTimeZone = (typeof localStorage.getItem('timezone') === 'undefined') ? null : localStorage.getItem('timezone');
        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

          this.offsetTimeZone = -5.00;
          this.offsetMinutes = 0;
          this.offsetTimeVal = (this.offsetTimeZone * 3600000);
        } else {

          this.offsetTimeZone = localStorage.getItem('timezone');
          this.offsetMinutes = 30;
          this.offsetTimeVal = (this.offsetTimeZone * 3600000);
        }

        const dateTimeZoneDiff = value.split(/[- :]/);
        const dateFinal = new Date(
          dateTimeZoneDiff[0],
          dateTimeZoneDiff[1] - 1,
          dateTimeZoneDiff[2],
          dateTimeZoneDiff[3],
          dateTimeZoneDiff[4],
          dateTimeZoneDiff[5]
        );
        dateFinal.setMilliseconds(Number(this.offsetTimeVal));

        const momentConfiguration = MomentConfiguration.spanish;
        moment.updateLocale(momentConfiguration.language, momentConfiguration.months);

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        if (dateFinal.toDateString() === today.toDateString()) {
          const formattedTimeString = moment(dateFinal).format(todayFormat);
          return `Hoy, ${formattedTimeString}`;
        } else {
          const dateString = moment(dateFinal).format('MM/DD/YYYY LT');
          const dateObj = new Date(dateString);
          const momentObj = moment(dateObj);
          const momentString = momentObj.format(otherDayformat);
          return momentString;
        }

      } else {
        return '';
      }
    }
  }
}
